<template>
  <app-dropdown
    placeholder="Filter by User Role"
    track-by="id"
    label="label"
    :options="roleSelection"
    v-bind="attrs"
    @on-selected="onUserRoleSelected"
    @on-removed="onUserRoleRemoved"
  />
</template>

<script>
import AppDropdown from "../AppComponents/AppDropdown.vue";
import UsersPerimeters from "../../configs/Perimeters/users";

/**
 * The value that indicates that selecting this from the
 * dropdown means the user is trying to select all
 * user roles.
 */
export const UserRoleListAllOption = {
  id: 0,
  label: "All User Roles"
};

export default {
  components: {
    AppDropdown
  },
  perimeters:[UsersPerimeters],
  computed: {
    // The rest of the attributes
    attrs() {
      const { placeholder, options, ...rest } = this.$attrs;
      return rest;
    },
    // Holds the data for the user role selection to be displayed
    roleSelection() {
      let selection = [
        UserRoleListAllOption,
        {
          id: "ROLE_AGENT_USER",
          label: "Agent"
        },
        {
          id: "ROLE_AGENT_ADMIN",
          label: "Office Admin"
        },
        {
          id: "ROLE_CLIENT_ADMIN",
          label: "Client Admin"
        }
      ];

      if (this.$isAllowed("viewFilterTodayAdmin")) {
        selection.push({
          id: "ROLE_ADMIN",
          label: "Today Admin"
        });
      }

      return selection;
    }
  },
  methods: {
    onUserRoleSelected(props) {
      this.$emit("on-user-role-selected", props);
    },
    onUserRoleRemoved(props) {
      this.$emit("on-user-role-removed", props);
    }
  },
  inheritAttrs: false
};
</script>
